import React, { useContext } from "react";
import { MANAGE_JOB, MODAL_STATES } from "../../../constant/Home/Jobs";
import Section from "../Details";
import Modal from "../../../Ui/Modal";
import ButtonComponent from "../../../Ui/Button";
import { UserContext } from "../../../context/UserContext";
const CancelJobComponent = ({ setModalState }) => {
  const { userData } = useContext(UserContext);
  return (
    <Modal
      open={true}
      maxWidth="953px"
      onClose={() => setModalState("")}
      logoDetail="Are You Sure You Would like to Cancel This Job?"
      title="Cancel Job"
      logo={userData.accountType == "VENDOR"}
      footer={
        <div className="flex w-full justify-between">
          <ButtonComponent
            paddingY="10px"
            onClick={() => setModalState(MODAL_STATES.MANAGE_JOB)}
          >
            Back
          </ButtonComponent>
          <ButtonComponent
            bgColor="#D40000"
            color="#FFFFFF"
            paddingY="10px"
            onClick={() => setModalState(MODAL_STATES.CANCELED_CONFIRMATION)}
          >
            Cancel Job
          </ButtonComponent>
        </div>
      }
    >
      {userData.accountType !== "VENDOR" ? (
        <div className="md:max-w-[660px]  mx-auto mb-8 px-[10px] md:px-[0px]">
          {[
            {
              number: "(i)",
              text: "If a Member cancels more than 2 hours before a scheduled Properteasy Service appointment, there is no cancellation fee.",
            },
            {
              number: "(ii)",
              text: "If the Member cancels during the 2 hours before a scheduled Properteasy Service appointment, the Member will be charged a $125 cancellation fee.",
            },
          ].map((policy, index) => (
            <div key={index} className="flex items-start gap-3">
              <span className="text-[#242424] text-[16px] font-medium">
                {policy.number} {policy.text}
              </span>
            </div>
          ))}
        </div>
      ) : null}
    </Modal>
  );
};

export default CancelJobComponent;
